import React from "react";
import { Col, Row, Typography } from "antd";
import { Button } from "../../publish/button";
import { ArrowRightIcon } from "@/icons/primary";

type Props = {
  page?: number;
  totalPages?: number;
  hasPrevious?: boolean;
  hasNext?: boolean;
  onPrevious?(): void;
  onNext?(): void;
};

const Pagination = ({
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  page = 1,
  totalPages = 1,
}: Props) => {
  return (
    <Row
      justify='center'
      align='middle'
      style={{
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "28px",
        letterSpacing: "2%",
        height: "47px",
      }}
      gutter={12.5}
    >
      <Col>
        <Button
          type='text'
          style={{
            padding: "8px 11px",
            minWidth: 0,
            color: "#A3ADB7",
            visibility: hasPrevious ? "visible" : "hidden",
          }}
          leftIcon={<ArrowRightIcon style={{ fontSize: "24px", rotate: "180deg" }} />}
          disabled={!hasPrevious}
          onClick={onPrevious}
        >
          Previous
        </Button>
      </Col>
      <Col>
        <Typography.Text
          style={{
            wordSpacing: "10px",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "28px",
            color: "#2C3B38",
            letterSpacing: "0.02em",
          }}
        >
          <span style={{ marginRight: 4 }}>{page}</span>/
          <span style={{ marginLeft: 4 }}>{totalPages}</span>
        </Typography.Text>
      </Col>

      {totalPages > 1 && (
        <Col>
          <Button
            type='text'
            style={{
              padding: "8px 11px",
              minWidth: 0,
              color: "#A3ADB7",
              visibility: hasNext ? "visible" : "hidden",
              fontWeight: 500,
            }}
            rightIcon={<ArrowRightIcon style={{ fontSize: "24px" }} />}
            disabled={!hasNext}
            onClick={onNext}
          >
            Next
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default Pagination;
